const baseQueryParams = {
  publicationState: 'live',
  sort: 'updatedAt:desc',
  pagination: {
    page: 1,
    pageSize: 100,
  },
};

export const topNewsQueryParams = {
  ...baseQueryParams,
  fields: ['name', 'url', 'is_top', 'updatedAt'],
  filters: {
    is_top: true,
  },
  pagination: { ...baseQueryParams.pagination, pageSize: 10 },
};

export const topCategoriesQueryParams = {
  ...baseQueryParams,
  sort: 'category_sequence:asc',
  filters: {
    news: {
      id: { $notNull: true },
    },
    // is_related_study_abroad: false,
  },
  fields: ['category_name'],
};

export const categoriesQueryParams = {
  ...topCategoriesQueryParams,
  populate: {
    news: {
      fields: ['excerpt', 'url', 'name', 'updatedAt', 'is_top', 'is_featured', 'author_name'],
      populate: {
        tags: {
          fields: ['tag_name'],
        },
        featured_image: {
          fields: ['name', 'url'],
        },
      },
      sort: ['updatedAt:desc'],
    },
  },
  pagination: { ...baseQueryParams.pagination, pageSize: 7 },
};

export const latestNewsQueryParams = {
  fields: ['name', 'url', 'excerpt', 'is_top', 'is_featured', 'author_name', 'updatedAt'],
  populate: {
    featured_image: {
      fields: ['name', 'url'],
    },
    tags: {
      fields: ['tag_name'],
    },
  },
  sort: ['updatedAt:desc'],
  publicationState: 'live',
  pagination: {
    page: 1,
    pageSize: 10,
  },
};

export const newsQueryParams = {
  ...baseQueryParams,
  fields: [...topNewsQueryParams.fields, 'is_top'],
  populate: {
    featured_image: {
      fields: ['url', 'name'],
    },
    news_cover_image: {
      fields: ['url', 'name'],
    },
    categories: {
      fields: ['category_name'],
      limit: 1,
    },
    tags: true,
  },
};

export const authorNewsQueryParams = {
  ...newsQueryParams,
  pagination: {
    page: 1,
    pageSize: 12,
  },
  sort: 'updatedAt:desc',
};

export const getNewsQueryParams = (page: number) => {
  return {
    ...newsQueryParams,
    pagination: {
      ...baseQueryParams.pagination,
      page,
    },
  };
};
